/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopayEntry
 */
export interface CopayEntry {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    value?: string;
    /**
     * 
     */
    note?: string;
}

/**
 * Check if a given object implements the CopayEntry interface.
 */
export function instanceOfCopayEntry(value: object): value is CopayEntry {
    return true;
}

export function CopayEntryFromJSON(json: any): CopayEntry {
    return CopayEntryFromJSONTyped(json, false);
}

export function CopayEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopayEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function CopayEntryToJSON(json: any): CopayEntry {
    return CopayEntryToJSONTyped(json, false);
}

export function CopayEntryToJSONTyped(value?: CopayEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
        'note': value['note'],
    };
}

